import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from 'src/store/store';

type NationalSampleAdminState = {
    isNationalSampleAdmin: boolean;
}

const initialState: NationalSampleAdminState = {
    isNationalSampleAdmin: false,
};

export const nationalSampleAdminSlice = createSlice({
    name: 'nationalSampleAdmin',
    initialState,
    reducers: {
        setIsNationalSampleAdmin: (state, action: PayloadAction<boolean>) => {
            state.isNationalSampleAdmin = action.payload;
        },
    }
});

export const {setIsNationalSampleAdmin} = nationalSampleAdminSlice.actions;
export const selectIsNationalSampleAdmin = (state: RootState) => state.nationalSampleAdmin.isNationalSampleAdmin;
export default nationalSampleAdminSlice.reducer;